import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from './icons';
import { useLanguage } from '../context/LanguageContext';
export function OneLiners() {
  const {
    t
  } = useLanguage();
  const quotes = t('oneLiners.quotes');
  return <section className="py-24 bg-brand-bg-dark" data-id="element-217">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-219">
          <div className="text-center mb-16" data-id="element-220">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-221">
              {t('oneLiners.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-222"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-223">
            {Array.isArray(quotes) && quotes.map((quote: string, index: number) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className="bg-brand-bg-light p-8 rounded-xl border border-gray-800 hover:border-brand-gold/50 transition-colors group relative overflow-hidden" data-id="element-224">
                  <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-225">
                    <QuoteIcon className="w-12 h-12 text-brand-gold" data-id="element-226" />
                  </div>
                  <p className="text-lg sm:text-xl text-gray-300 font-medium italic relative z-10 leading-relaxed" data-id="element-227">
                    "{quote}"
                  </p>
                </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}